"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeChartProps = exports.mergeChartPropsCustomizer = void 0;
const lodash_1 = require("lodash");
const mergeChartPropsCustomizer = (value, srcValue, key, object, source) => {
    return key === 'data' || Array.isArray(value) ? srcValue : undefined;
};
exports.mergeChartPropsCustomizer = mergeChartPropsCustomizer;
const mergeChartProps = (props, sampleProps, ...defaultProps) => (0, lodash_1.mergeWith)({}, ...defaultProps, props.showSampleData ? sampleProps : undefined, props, exports.mergeChartPropsCustomizer);
exports.mergeChartProps = mergeChartProps;
//# sourceMappingURL=common.js.map